import {
  BaseActionObject,
  StateNodeConfig,
  assign,
  DoneInvokeEvent
} from "xstate4"
import { Context, Transitions } from "../../../types"
import { getServiceErrorMessage } from "../../../helpers"

export const saveDraftPlanSettingsTransition: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  invoke: {
    src: "saveDraftPlanSettings",
    onDone: {
      target: "idle",
      actions: assign<Context, DoneInvokeEvent<any>>((ctx, evt) => {
        return {
          studyPlan: evt.data.plan,
          snackbar: {
            message: "Settings applied. Save to keep the changes.",
            withUndo: true,
            error: false
          }
        }
      })
    },
    onError: {
      target: "idle",
      actions: assign<Context, DoneInvokeEvent<any>>({
        snackbar: (_ctx, _evt) => ({
          message: getServiceErrorMessage("saveStudyPlanSettings", {
            messageData: ["save plan error"]
          }),
          withUndo: false,
          error: true
        })
      })
    }
  }
}
